(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scentci-catalogue"] && !Shopify.designMode) return;
  try {
    
if (!window.scentciCatalogReady) {
 window.scentciCatalogReady = true;
 document.addEventListener('click', (event) => {
  const scroll = event.target.closest('[data-sc-scroll]'); if (scroll) { const list = scroll.closest('[data-sc-catalog]').querySelector('.sc-products'); list.scrollBy({left: Number(scroll.dataset.scScroll) * list.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}); }
  const opener = event.target.closest('[data-open]');
  if (opener) { const dialog = document.getElementById(opener.dataset.open); if (dialog) { dialog.showModal(); dialog._opener = opener; } }
  const closer = event.target.closest('[data-close]');
  if (closer) { const dialog = closer.closest('dialog'); dialog.close(); dialog._opener?.focus(); }
  if (event.target.matches('dialog.sc-product-dialog')) { const box = event.target.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close(); }
  const filter = event.target.closest('[data-filter]');
  if (filter) { const section = filter.closest('[data-sc-catalog]'); section.dataset.filter = filter.dataset.filter; section.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === filter))); updateCatalog(section); }
 });
 document.addEventListener('input', (event) => { if (event.target.matches('[data-sc-search]')) updateCatalog(event.target.closest('[data-sc-catalog]')); });
 function updateCatalog(section) { const filter = section.dataset.filter || 'all'; const term = (section.querySelector('[data-sc-search]')?.value || '').toLocaleLowerCase('fr'); let shown = 0; section.querySelectorAll('.sc-product').forEach(card => { const matchGender = filter === 'all' || card.dataset.gender.includes(filter) || card.dataset.gender === 'Mixte'; const matchText = card.dataset.search.toLocaleLowerCase('fr').includes(term); card.hidden = !(matchGender && matchText); if (!card.hidden) shown++; }); section.querySelector('.sc-no-results').hidden = shown > 0; }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scentci-header"] && !Shopify.designMode) return;
  try {
    
if (!window.scentciMotionReady) {
  window.scentciMotionReady = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  function reveal(root = document) {
    if (reduced.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    observer ||= new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('sc-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06 });
    root.querySelectorAll('.sc-section-heading, .sc-product, .sc-universe, .sc-offer-inner, .sc-faq > div').forEach((element, index) => {
      if (element.classList.contains('sc-reveal')) return;
      element.style.setProperty('--sc-reveal-delay', `${element.classList.contains('sc-product') ? index % 4 * 45 : 0}ms`);
      element.classList.add('sc-reveal');
      observer.observe(element);
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sc-motion-toggle]');
    if (!button) return;
    const paused = document.documentElement.dataset.scMotionPaused !== 'true';
    document.documentElement.dataset.scMotionPaused = String(paused);
    document.querySelectorAll('[data-sc-motion-toggle]').forEach(control => {
      control.setAttribute('aria-pressed', String(paused));
      control.setAttribute('aria-label', paused ? control.dataset.resumeLabel : control.dataset.pauseLabel);
    });
  });
  reduced.addEventListener('change', () => {
    if (reduced.matches) {
      observer?.disconnect();
      document.querySelectorAll('.sc-reveal').forEach(element => element.classList.add('sc-visible'));
    } else reveal();
  });
  document.addEventListener('visibilitychange', () => {
    document.documentElement.dataset.scMotionHidden = String(document.hidden);
  });
  document.addEventListener('shopify:section:load', event => reveal(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => reveal());
  else reveal();
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scentci-hero"] && !Shopify.designMode) return;
  try {
    
if (!window.scentciSlidesReady) {
 window.scentciSlidesReady = true;
 function initSlides(root = document) { root.querySelectorAll('[data-sc-slideshow]').forEach(hero => {
  if (hero._scInit) return; hero._scInit = true;
  const slides = [...hero.querySelectorAll('[data-sc-slide]')], dots = [...hero.querySelectorAll('[data-sc-dot]')], reduced = matchMedia('(prefers-reduced-motion: reduce)');
  if (!slides.length) return;
  let active = 0, timer, paused = false, hover = false;
  function schedule() { clearTimeout(timer); if (slides.length > 1 && hero.dataset.autoplay === 'true' && !paused && !hover && !reduced.matches && !document.hidden && !window.Shopify?.designMode && document.documentElement.dataset.scMotionPaused !== 'true') timer = setTimeout(() => show(active + 1), Number(hero.dataset.duration)); }
  function show(index) { active = (index + slides.length) % slides.length; slides.forEach((slide, i) => { slide.hidden = i !== active; }); dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === active))); schedule(); }
  hero.querySelector('[data-sc-prev]').addEventListener('click', () => show(active - 1)); hero.querySelector('[data-sc-next]').addEventListener('click', () => show(active + 1));
  dots.forEach((dot,i) => dot.addEventListener('click', () => show(i)));
  hero.querySelector('[data-sc-slide-pause]').addEventListener('click', event => { paused = !paused; event.currentTarget.setAttribute('aria-pressed', String(paused)); event.currentTarget.setAttribute('aria-label', paused ? 'Reprendre le bandeau' : 'Mettre le bandeau en pause'); event.currentTarget.textContent = paused ? '▷' : 'Ⅱ'; schedule(); });
  hero.addEventListener('mouseenter', () => { hover = true; schedule(); }); hero.addEventListener('mouseleave', () => { hover = false; schedule(); });
  hero.addEventListener('focusin', () => { hover = true; schedule(); }); hero.addEventListener('focusout', event => { if (!hero.contains(event.relatedTarget)) { hover = false; schedule(); } });
  document.addEventListener('visibilitychange', schedule); reduced.addEventListener('change', schedule);
  document.addEventListener('click', event => { if (event.target.closest('[data-sc-motion-toggle]')) schedule(); });
  document.addEventListener('shopify:block:select', event => { const index = slides.findIndex(slide => slide.contains(event.target) || slide === event.target); if (index >= 0) show(index); });
  document.addEventListener('shopify:section:unload', event => { if (event.target.contains(hero)) clearTimeout(timer); }); schedule();
 }); }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initSlides()); else initSlides();
 document.addEventListener('shopify:section:load', event => initSlides(event.target));
}

  } catch(e) { console.error(e); }
})();
})();
